import { render, staticRenderFns } from "./_StockFilters.vue?vue&type=template&id=f8d4122e&"
import script from "./_StockFilters.vue?vue&type=script&lang=js&"
export * from "./_StockFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports